// extracted by mini-css-extract-plugin
export default {"settingSection":"SettingsBlock_settingSection__6zJJR","contentWrapper":"SettingsBlock_contentWrapper__Ts3-I"};